export enum API_ROUTES {
  ANALYTICS = "/api/Analytics",
  ANALYTICS_JOB = "/api/AnalyticsJob",
  AUTHENTICATION = "/api/authentication",
  SCORING_SCHEDULE = "/api/AutoQASchedule",
  CONVERSATION_DETAILS = "/api/ConversationDetails",
  CONVERSATION_PLAYBACK = "/api/ConversationPlayback",
  FILTERS = "/api/filters",
  PERFORMANCE_DETAILS = "/api/PerformanceDetails",
  QUICK_FILTERS = "/api/QuickFilter",
  SCORECARD = "/api/Scorecard",
  SEARCH = "/api/Search",
  SHARED_LINK = "/api/SharedLink",
  SUCCESS_INTELLIGENCE_METRICS = "/api/SuccessIntelligenceMetrics",
  USER_PROFILE = "/api/UserProfile",
};